<template>
  <div>
    <el-card><el-row class="title-biaoti">汇率换算配置</el-row> <el-row class="search">
        <el-input type="text" v-model="search.usPrice" placeholder="请输入美元价格"></el-input>
        <el-select v-model="search.countryCode" placeholder="请选择国家" clearable="" filterable="">
          <el-option v-for="(item, itemIndex) in countryLists" v-bind:key="itemIndex + 99" :label="item.country"
            :value="item.countryCode"></el-option>
        </el-select>
        <el-select v-model="search.countryCurrency" placeholder="请选择货币类型" clearable filterable>
          <el-option v-for="currency in currencies" :key="currency" :label="currency" :value="currency"></el-option>
        </el-select>
        <el-button type="primary" @click="searchData" :loading="login"> 查询 </el-button>

        <!-- <el-button type="success" @click="operate(1)"> 新增</el-button> -->
        <el-button type="success" @click="priceVisible = true">管理价格</el-button>
        <el-button type="success" @click="countryVisible = true">管理国家</el-button>
        <!-- <el-button type="danger" @click="delCountry">删除国家</el-button> -->

        <el-button v-if="selectedRows.length > 1" type="primary" @click="openBatchConfig">
          批量配置 ({{ selectedRows.length }})
        </el-button>

        <el-button type="warning" @click="resetSearch"> 重置</el-button></el-row>
      <el-row>
        <el-table height="65vh" :data="dataList" style="width: 100%" v-loading="login" border
          @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55" align="center"></el-table-column>
          <el-table-column prop="id" label="ID" align="center" sortable width="80">
          </el-table-column>
          <el-table-column prop="usPrice" label="美元价格" align="center" sortable :sort-method="sortMPrice" width="120">
          </el-table-column>
          <el-table-column prop="countryCurrency" label="货币类型" align="center" sortable width="100">
          </el-table-column>
          <el-table-column prop="currencySymbol" label="货币符号" align="center" width="100">
          </el-table-column>
          <el-table-column prop="countryCodeList" label="国家代码" align="center" width="150">
            <template slot-scope="scope">
              {{ Array.isArray(scope.row.countryCodeList) ? scope.row.countryCodeList.join(',') :
                scope.row.countryCodeList || '' }}
            </template>
          </el-table-column>
          <el-table-column prop="countryCodeList" label="国家" align="center" width="200">
            <template slot-scope="scope">
              {{ getCountryNamesByCodeList(scope.row.countryCodeList) }}
            </template>
          </el-table-column>
          <el-table-column prop="countryPrice" label="当地价格" align="center" sortable :sort-method="sortPrice"
            width="150">
            <template slot-scope="scope">
              <EditableCell :value="scope.row.countryPrice" :display-value="scope.row.countryPrice" input-type="decimal"
                :decimal-places="2" @update="handlePriceUpdate(scope.row, $event)" />
            </template>
          </el-table-column>
          <el-table-column prop="referenceCountryPrice" label="参考国家价格" align="center" sortable
            :sort-method="sortOther('referenceCountryPrice')" width="150">
            <template slot-scope="scope">
              <span :class="{
                red: scope.row.referenceCountryPrice && (scope.row.referenceCountryPrice / scope.row.countryPrice > 1.1),
                green: scope.row.referenceCountryPrice && (scope.row.referenceCountryPrice / scope.row.countryPrice < 0.9),
              }">
                {{ scope.row.referenceCountryPrice }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="calculateRate" label="计算汇率" align="center" sortable
            :sort-method="sortOther('calculateRate')" width="120">
          </el-table-column>
          <el-table-column prop="queryRate" label="查询汇率" align="center" sortable :sort-method="sortOther('queryRate')"
            width="120">
          </el-table-column>
          <el-table-column prop="ctime" label="创建时间" align="center" sortable width="150">
          </el-table-column>
          <el-table-column prop="mtime" label="更新时间" align="center" sortable width="150">
          </el-table-column>
          <el-table-column prop="operator" label="操作人" align="center" sortable width="100">
          </el-table-column>
          <el-table-column label="操作" align="center">

            <template slot-scope="scope">
              <el-button type="primary" size="mini" @click="operate(2, scope.row)">编辑</el-button>
              <el-button type="warning" size="mini" @click="operate(3, scope.row.id)">删除</el-button>
            </template>
          </el-table-column></el-table></el-row>

      <!-- 分页 -->
      <el-row style="margin-top: 20px;">
        <div class="pagination-container" style="text-align: center;">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="pagination.page" :page-sizes="[10, 20, 50, 100]" :page-size="pagination.pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="pagination.total">
          </el-pagination>
        </div>
      </el-row>
    </el-card>
    <el-dialog :title="type === 1 ? '新增汇率配置' : '编辑汇率配置'" :visible.sync="dialog" width="50%" :before-close="handleClose">
      <div class="item">
        <span>美元价格</span><el-input type="text" v-model="priceform.usPrice" :disabled="type !== 1"></el-input>
      </div>
      <div class="item">
        <span>国家</span><el-select v-model="priceform.countryCode" :disabled="type !== 1" placeholder="请选择国家"
          clearable="" filterable="">
          <el-option v-for="(item, itemIndex) in countryList" v-bind:key="itemIndex + 99" :label="item.country"
            :value="item.countryCode"></el-option>
        </el-select>
      </div>
      <div class="item">
        <span>货币类型</span>
        <el-select v-model="priceform.countryCurrency" :disabled="type !== 1" placeholder="请选择货币类型" clearable
          filterable>
          <el-option v-for="currency in currencies" :key="currency" :label="currency" :value="currency"></el-option>
        </el-select>
      </div>
      <div class="item">
        <span>当地价格</span><el-input type="text" v-model="priceform.countryPrice"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="modifyPrice" type="primary">{{
          type === 1 ? "新 增" : "编 辑"
        }}</el-button>
        <el-button @click="handleClose">取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog title="管理价格" :visible.sync="priceVisible" width="50%">
      <PriceConfig />
    </el-dialog>
    <el-dialog title="新增国家" :visible.sync="countryVisible" width="900px">
      <!-- <div style="margin-bottom: 20px;">
        <span>国家代码: </span><el-input type="text" v-model="addData.countryCode"
          style="width: 300px;margin-right: 20px;"></el-input>
      </div>
      <div>
        <span>货币类型: </span><el-input type="text" v-model="addData.countryCurrency"
          style="width: 300px;margin-right: 20px;"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="countryVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitAdd">确 定</el-button>
      </span> -->
      <CountryConfig></CountryConfig>
    </el-dialog>

    <!-- 批量配置弹窗 -->
    <BatchPriceConfig :visible.sync="batchConfigVisible" :selected-items="selectedRows"
      @batch-update="handleBatchUpdate" />
  </div>
</template>

<script>
import PriceConfig from '@/components/price/PriceConfig.vue'
import CountryConfig from '@/components/price/CountryConfig.vue'
import BatchPriceConfig from '@/components/common/BatchPriceConfig.vue'
import EditableCell from '@/components/common/EditableCell.vue'
import { formatTimeStamp } from "@/utils/common";
import { getCountryMore } from '@/utils/normalApi.js'
import {
  addCountry,
  delCountry,
  getEnhancedPriceList,
  batchUpdatePrice,
  getAvailableCountryList
} from '../../api/priceRequest'
export default {
  components: {
    PriceConfig,
    CountryConfig,
    BatchPriceConfig,
    EditableCell
  },
  data() {
    return {
      login: false,
      dialog: false,
      dataList: [],
      countryList: [],
      countryLists: [],
      currencies: [], // 可选的货币类型列表
      type: 1,
      search: {
        usPrice: "",
        countryCode: "",
        countryCurrency: "",
      },
      // 分页相关
      pagination: {
        page: 1,
        pageSize: 20,
        total: 0
      },
      // 勾选相关
      selectedRows: [],
      batchConfigVisible: false,
      priceform: {
        id: "",
        usPrice: "",
        countryCode: "",
        countryCurrency: "",
        countryPrice: "",
      },
      addData: {
        countryCode: '',
        countryCurrency: ''
      },
      priceVisible: false,
      countryVisible: false
    };
  },
  async created() {
    this._getCountry();
    this._getCountrys();
    this.query();

  },
  methods: {
    getRealCountryByCode(code) {
      let res = this.countryList.find((item) => item.countryCode === code)
      if (!res) return ''
      return res.country
    },
    async _getCountrys() {
      const res = await getCountryMore()
      if (res !== null) {
        this.countryLists = res.countryList
      }
    },
    async submitAdd() {
      if (this.addData.countryCode.trim() === '' || this.addData.countryCurrency.trim() === '') {
        return this.$message.error('数据不能为空')
      }
      const res = await addCountry({
        ... this.addData
      })
      if (res.code == 0) {
        this.$message.success(res.msg)
        this.countryVisible = false
        this.query();
      } else {
        this.$message.error(res.msg)
      }
    },
    addCountry() {
      this.addData = {
        countryCode: '',
        countryCurrency: ''
      }
      this.countryVisible = true;
    },
    delCountry() {
      this.$prompt('请输入删除国家代码', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(async ({ value }) => {
        if (!/^[\s\S]*\S[\s\S]*$/.test(value)) {
          return this.$message.error('不能为空')
        }
        const res = await delCountry(value.trim())
        if (res.code == 0) {
          this.$message.success(res.msg)
          this.query();
        } else {
          this.$message.error(res.msg)
        }
      }).catch(() => {
      });
    },
    sortOther(code) {
      return (a, b) => {
        // console.log(a, b);
        if (a[code] == 'unknow' || !a[code]) return -10000000
        if (b[code] == 'unknow' || !b[code]) return 10000000
        return a[code] - b[code]
      }
    },
    sortPrice(a, b) {
      return a.countryPrice - b.countryPrice
    },
    sortMPrice(a, b) {
      return a.usPrice - b.usPrice
    },
    async _getCountry() {
      try {
        const res = await getAvailableCountryList('all');
        if (res.code === 0) {
          // 根据接口返回的数据格式进行适配
          if (res.data && res.data.list) {
            // 如果返回的是标准格式的国家列表
            this.countryList = res.data.list.map(code => ({
              countryCode: code,
              country: code
            }));
          } else if (Array.isArray(res.data)) {
            // 如果直接返回国家代码数组
            this.countryList = res.data.map(code => ({
              countryCode: code,
              country: code
            }));
          }
        } else {
          console.error('获取国家列表失败:', res.msg);
        }
      } catch (error) {
        console.error('获取国家列表失败:', error);
      }
    },
    async query() {
      this.login = true;
      try {
        const res = await getEnhancedPriceList({
          usPrice: this.search.usPrice,
          countryCode: this.search.countryCode,
          countryCurrency: this.search.countryCurrency,
          page: this.pagination.page,
          pageSize: this.pagination.pageSize,
        });

        if (res.code !== 0) {
          this.$message.error(res.msg || '查询失败');
          return;
        }

        this.dataList = res.data.list || [];
        this.pagination.total = res.data.total || 0;

        // 提取可用的货币类型列表
        if (res.data.currencies && Array.isArray(res.data.currencies)) {
          this.currencies = res.data.currencies;
        }

        this.dataList.forEach((item) => {
          if (item.ctime)
            item.ctime = formatTimeStamp(item.ctime, "YYYY-MM-DD HH:mm:ss");
          if (item.mtime)
            item.mtime = formatTimeStamp(item.mtime, "YYYY-MM-DD HH:mm:ss");
        });
      } catch (error) {
        console.error('查询失败:', error);
        this.$message.error('查询失败，请重试');
      } finally {
        this.login = false;
      }
    },
    async modifyPrice() {
      let data = {
        usPrice: this.priceform.usPrice,
        countryCode: this.priceform.countryCode,
        countryCurrency: this.priceform.countryCurrency,
        countryPrice: this.priceform.countryPrice,
      };
      if (this.type === 2) {
        data.id = this.priceform.id;
      }
      const { data: res } = await this.$axios.post(
        this.$store.getters.path.config_price_update +
        "?username=" +
        this.$store.getters.username +
        "&token=" +
        this.$store.getters.token,
        { data: data }
      );
      if (res.code != 0) return this.$message(res.msg);
      this.$message.success("操作成功");
      this.query();
      this.handleClose();
    },
    resetSearch() {
      this.search = {
        usPrice: "",
        countryCode: "",
        countryCurrency: "",
      };
      this.pagination.page = 1;
      this.query();
    },
    operate(type, obj) {
      this.type = type;
      if (type === 2) {
        this.priceform = { ...obj };
      } else if (type === 3) {
        this.$confirm("确认删除此项汇率配置", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(async () => {
            const { data: res } = await this.$axios.post(
              this.$store.getters.path.config_price_delete +
              "?username=" +
              this.$store.getters.username +
              "&token=" +
              this.$store.getters.token,
              { data: { id: obj } }
            );
            if (res.code !== 0) return this.$message.error("删除失败");
            this.$message.success("删除成功");
            this.query();
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      }
      if (type !== 3) this.dialog = true;
    },
    handleClose() {
      this.priceform = {
        id: "",
        usPrice: "",
        countryCode: "",
        countryCurrency: "",
        countryPrice: "",
      };
      this.dialog = false;
    },

    // ==================== 分页相关方法 ====================

    // 搜索数据（重置分页）
    searchData() {
      this.pagination.page = 1;
      this.query();
    },

    // 分页大小改变
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.pagination.page = 1;
      this.query();
    },

    // 当前页改变
    handleCurrentChange(val) {
      this.pagination.page = val;
      this.query();
    },

    // ==================== 新增方法 ====================

    // 处理表格勾选变化
    handleSelectionChange(selection) {
      this.selectedRows = selection;
    },

    // 打开批量配置弹窗
    openBatchConfig() {
      if (this.selectedRows.length < 2) {
        this.$message.warning('请至少选择2条数据进行批量配置');
        return;
      }
      this.batchConfigVisible = true;
    },

    // 处理批量更新
    async handleBatchUpdate(priceList) {
      try {
        const res = await batchUpdatePrice(priceList);

        if (res.code === 0) {
          // 更健壮的成功消息处理
          const successCount = res.data?.successCount || priceList.length;
          const failCount = res.data?.failCount || 0;

          this.$message.success(`批量更新成功：${successCount} 条记录`);
          if (failCount > 0) {
            this.$message.warning(`${failCount} 条记录更新失败`);
          }
          this.batchConfigVisible = false;
          this.selectedRows = [];
          this.query(); // 刷新列表
        } else {
          this.$message.error(res.msg || '批量更新失败');
        }
      } catch (error) {
        console.error('批量更新失败:', error);
        this.$message.error('批量更新失败，请重试');
      }
    },

    // 处理单个价格内联编辑更新
    async handlePriceUpdate(row, newValue) {
      try {
        const priceList = [{
          id: row.id,
          countryPrice: newValue.toString()
        }];

        const res = await batchUpdatePrice(priceList);

        if (res.code === 0) {
          this.$message.success('价格更新成功');
          // 更新本地数据
          row.countryPrice = newValue.toString();
        } else {
          this.$message.error(res.msg || '价格更新失败');
        }
      } catch (error) {
        console.error('价格更新失败:', error);
        this.$message.error('价格更新失败，请重试');
      }
    },

    // 根据国家代码列表获取国家名称
    getCountryNamesByCodeList(codeList) {
      if (!codeList) return '';

      const codes = Array.isArray(codeList) ? codeList : codeList.split(',');
      const names = codes.map(code => {
        const country = this.countryList.find(item => item.countryCode === code.trim());
        return country ? country.country : code.trim();
      });

      return names.join(', ');
    },

    // 格式化价格显示（智能显示位数）
    formatPriceDisplay(price) {
      if (!price) return '0';

      const numPrice = parseFloat(price);
      if (isNaN(numPrice)) return price;

      // 智能显示位数逻辑
      if (numPrice >= 1000) {
        return Math.round(numPrice).toString(); // 千位以上显示整数
      } else if (numPrice >= 100) {
        return (Math.round(numPrice * 10) / 10).toString(); // 百位显示1位小数
      } else if (numPrice >= 10) {
        return numPrice.toFixed(1); // 十位显示1位小数
      } else {
        return numPrice.toFixed(2); // 个位显示2位小数
      }
    },

  },
};
</script>

<style scoped lang="scss">
.search {
  display: flex;

  >* {
    margin: 0 5px;
  }

  .el-input {
    width: 300px;
  }
}

.cell {
  display: flex;

  >* {
    margin: 2px;
  }
}

.item {
  display: flex;
  align-items: center;
  padding: 5px 0;

  span {
    white-space: nowrap;
    padding: 0 5px;
  }
}

.red {
  color: #ef696c;
}

.green {
  color: #85cb61;
}

.pagination-container {
  border-top: 1px solid #ebeef5;
  padding-top: 20px;
}
</style>
